import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { PreloaderService, SettingsService } from '@core/bootstrap';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { environment } from '@env/environment';
import { WINDOW } from '@core/injection-tokens';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private _subscription = new Subscription();
  private _bodyElement!: HTMLBodyElement;

  constructor(
    private readonly _preloader: PreloaderService,
    private readonly _settings: SettingsService,
    private readonly _renderer: Renderer2,
    @Inject(DOCUMENT) private readonly _document: Document,
    @Inject(WINDOW) private readonly _window: Window
  ) {}

  ngOnInit() {
    this._settings.updateScheme();
    this._settings.updateTheme();
    this._appendPreconnectLink();
  }

  ngAfterViewInit(): void {
    this._preloader.hide();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  private _appendPreconnectLink(): void {
    const preconnectHost =
      environment.STAGE === 'local'
        ? this._window.location.origin
        : new URL(environment.ASSET_URL).origin;

    const link: HTMLLinkElement = this._renderer.createElement(
      'link'
    ) as HTMLLinkElement;
    link.rel = 'preconnect';
    link.href = preconnectHost;
    this._renderer.appendChild(this._document.head, link);
  }
}
